import { useContext } from 'react';

import { FEATURE_FLAGS_FOR_SELLER } from '@savgroup-front-common/constants';
import { useGetFeatureFlagsQuery } from '@savgroup-front-common/core/api/Authorization/useGetFeatureFlagsQuery';

import { InitContext } from '../NewLayout/InitProvider/InitProvider.context';

export function useHasForceOneProductPerClaim(): boolean {
  const { orders } = useContext(InitContext);
  const sellerId = orders?.at(0)?.sellerId;

  return useGetFeatureFlagsQuery({
    featureFlag: [FEATURE_FLAGS_FOR_SELLER.FORCE_ONE_PRODUCT_PER_CLAIM],
    sellerId,
    suspense: false,
  });
}
